<div class="modal-header border-bottom-0 pt-4 pb-2 px-4 align-items-center position-absolute top-0 w-100 bg-white">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" aria-label="Close" class="close bg-light rounded-3 py-2 m-0" (click)="onCloseClick.emit()">
    <span aria-hidden="true">
      <img src="../../../assets/img/close-icon.svg" alt="Close Icon">
    </span>
  </button>
</div>